import { createContext } from "react"

const Account = createContext({})

export default Account
